<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="fc3dForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="起始期数">
        <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
        -
        <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
      </el-form-item>
      <el-form-item label="数字1" prop="num1">
        <el-input v-model="queryParams.num1" placeholder="数字1" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字2" prop="num2">
        <el-input v-model="queryParams.num2" placeholder="数字2" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字3" prop="num3">
        <el-input v-model="queryParams.num3" placeholder="数字3" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryFc3d">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQueryFc3d">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllFc3d">
          全部初始化
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillFc3dHistory">
          补全历史数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:export']" type="warning" plain icon="el-icon-export" size="mini" @click="handleExportFc3d">导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:initC']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleInitAllFc3dC">
          初始化统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:exportC']" type="warning" plain icon="el-icon-export" size="mini" @click="handleOpenC()">导出统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:cache']" type="danger" plain icon="el-icon-export" size="mini" @click="handleRefreshFc3d">刷新缓存
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:gen']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleOpenGenerateFc3d">
          生成福彩3D
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:fc3d:exportF']" type="warning" plain icon="el-icon-export" size="mini" @click="exportFrequency">导出组合频率
        </el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getFc3dList" />
    </el-row>
    <el-table :data="fc3dList" v-loading="loading" border highlight-current-row
              :cell-class-name="cellClassName">
      <el-table-column label="期号" align="center" prop="period"/>
      <el-table-column label="数字号码" align="center">
        <el-table-column label="1" align="center" prop="num1"/>
        <el-table-column label="2" align="center" prop="num2"/>
        <el-table-column label="3" align="center" prop="num3"/>
      </el-table-column>
      <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.saleAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="开奖日期" align="center" prop="lotteryDate" min-width="90px">
        <template slot-scope="scope">
          {{ scope.row.lotteryDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="210px">
        <template slot-scope="scope">
          <el-button v-hasPermi="['lottery:fc3d:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          <el-button v-hasPermi="['lottery:fc3d:next']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期</el-button>
          <el-button v-hasPermi="['lottery:fc3d:nextF']" type="text" icon="el-icon-medal" @click="handleNextNum(scope.row.period)">频率</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getFc3dList"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 导出统计次数弹出层 -->
    <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
      <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
        <el-form-item prop="isC">
                <span slot="label">
                  是否排序
                  <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </span>
          <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
            <el-option :key="true" label="是" :value="true"></el-option>
            <el-option :key="false" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportC">导出</el-button>
        <el-button @click="cancelC">取消</el-button>
      </div>
    </el-dialog>
    <!-- 生成福彩3D弹出层 -->
    <el-dialog title="生成福彩3D" :visible.sync="generateFc3dOpen" width="750px" :close-on-click-modal="false">
      <el-form ref="generateFc3dForm" :model="generateFc3dForm" :inline="true" :rules="generateFc3dRules"
               label-width="80px">
        <el-form-item label="生成个数" prop="count">
          <el-select v-model="generateFc3dForm.count" placeholder="请选择个数">
            <el-option :key="1" label="1" :value="1"/>
            <el-option :key="5" label="5" :value="5"/>
            <el-option :key="10" label="10" :value="10"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGenerateFc3d">生成</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetGenerateFc3d">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="generateFc3dList" border style="width: 100%" :cell-class-name="cellClassName"
                highlight-current-row>
        <el-table-column label="数字号码" align="center">
          <el-table-column label="1" align="center" prop="num1"/>
          <el-table-column label="2" align="center" prop="num2"/>
          <el-table-column label="3" align="center" prop="num3"/>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期中奖概率弹出层 -->
    <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
      <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
        <el-col :span="8">{{ item.name }}</el-col>
        <el-col :span="8">注数：{{ item.count }}</el-col>
        <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 下期福彩3D同期历史数据弹出层 -->
    <el-dialog :title="fc3dHistoryTitle" :visible.sync="fc3dHistoryOpen" width="600px" :close-on-click-modal="false">
      <el-tabs v-model="activeFc3dHistoryName" type="border-card">
        <el-tab-pane label="历史同期数据" name="firstFc3d">
          <el-table :data="fc3dHistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                    highlight-current-row>
            <el-table-column label="期数" align="center" prop="period" width="70"/>
            <el-table-column label="数字号码" align="center">
              <el-table-column label="1" align="center" prop="num1"/>
              <el-table-column label="2" align="center" prop="num2"/>
              <el-table-column label="3" align="center" prop="num3"/>
            </el-table-column>
            <el-table-column label="总和" align="center" prop="totalSum"/>
            <el-table-column label="跨度" align="center" prop="numSpan"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="统计数据" name="secondFc3d">
          <el-row :gutter="10">
            <el-col :span="6" style="text-align: right">数字1次数排名：</el-col>
            <el-col :span="18">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in fc3dHistoryRedOneList" :key="item.num" :span="6"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6" style="text-align: right">数字2次数排名：</el-col>
            <el-col :span="18">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in fc3dHistoryRedTwoList" :key="item.num" :span="6"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6" style="text-align: right">数字3次数排名：</el-col>
            <el-col :span="18">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in fc3dHistoryRedThreeList" :key="item.num" :span="6"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fc3dHistoryOpen=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 下期福彩3D数字频率弹出层 -->
    <el-dialog :title="fc3dNumTitle" :visible.sync="fc3dNumOpen" width="1200px" :close-on-click-modal="false">
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">全部数字：</el-col>
        <el-col :span="22">
          <el-row v-for="item in allList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">同位数字：</el-col>
        <el-col :span="22">
          <el-row v-for="item in digitList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fc3dNumOpen=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  listFc3d,
  initAllFc3d,
  fillHistoryData,
  initAllFc3dC,
  refreshFc3dCache,
  generateFc3d,
  getFc3dWinningData,
  getNextFc3dHistory,
  getNextNumFrequency
} from '@/api/lottery/fc3d'

export default {
  data() {
    return {
      // 遮罩层
      loading: '',
      showSearch:true,
      //福彩3D数据
      fc3dList: [],
      // 福彩3D数量
      total: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null,
        num1: null,
        num2: null,
        num3: null,
      },
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generateFc3dOpen: false,
      generateFc3dForm: {
        count: 1
      },
      generateFc3dRules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generateFc3dList: [],
      winningList: [],
      winningOpen: false,

      activeFc3dHistoryName: 'firstFc3d',
      fc3dHistoryOpen: false,
      fc3dHistoryTitle: '',
      fc3dHistoryList: [],
      fc3dHistoryRedOneList: [],
      fc3dHistoryRedTwoList: [],
      fc3dHistoryRedThreeList: [],

      fc3dNumTitle: '',
      fc3dNumOpen: false,
      allList: [],
      digitList: []
    }
  },
  created() {
    this.getFc3dList()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property === 'num1' || column.property === 'num2' || column.property === 'num3') {
          return 'red-ball';
        }
      }
    },
    /** 查询福彩3D列表 */
    getFc3dList() {
      listFc3d(this.queryParams).then(res => {
        this.fc3dList = res.rows;
        this.total = res.total
      })
    },
    /** 搜索福彩3D列表 **/
    handleQueryFc3d() {
      this.queryParams.current = 1;
      this.getFc3dList()
    },
    /** 重置福彩3D按钮操作 */
    resetQueryFc3d() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;

      this.resetForm("fc3dForm");
      this.handleQueryFc3d();
    },
    /** 初始化福彩3D数据 **/
    handleInitAllFc3d() {
      this.$modal.confirm("确定要初始化全部福彩3D数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
        this.$modal.loading("正在初始化中，请稍后...")
          initAllFc3d().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryFc3d();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
            }
      }).catch(()=> {})
    },
    /** 补全福彩3D历史数据 **/
    handleFillFc3dHistory() {
      this.$modal.confirm("确定要补全福彩3D历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQueryFc3d();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },

    /** 导出大福彩3D按钮操作 */
    handleExportFc3d() {
      this.download('/admin/lottery/fc3d/export', {
        ...this.queryParams
      }, `福彩3D导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化福彩3D统计数据 **/
    handleInitAllFc3dC() {
      this.$modal.confirm("确定要初始化福彩3D统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllFc3dC().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryFc3d();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新福彩3D缓存 **/
    handleRefreshFc3d() {
      refreshFc3dCache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 打开生成福彩3D弹窗 */
    handleOpenGenerateFc3d() {
      this.generateFc3dOpen = true;
      this.$set(this.generateFc3dForm, 'count', 1)
      this.resetForm("generateFc3dForm");
      this.generateFc3dList = []
    },
    handleGenerateFc3d() {
      this.$refs["generateFc3dForm"].validate(valid => {
        if (valid) {
          generateFc3d(this.generateFc3dForm).then(res => {
            if (res.flag) {
              this.generateFc3dList = res.data
            }
          })
        }
      })
    },
    resetGenerateFc3d() {
      this.generateFc3dList = []
      this.$set(this.generateFc3dForm, 'count', 1)
      this.resetForm("generateFc3dForm");
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        num1: row.num1,
        num2: row.num2,
        num3: row.num3,
        period: row.period
      }
      getFc3dWinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.fc3dHistoryList = [];
      this.fc3dHistoryRedOneList = [];
      this.fc3dHistoryRedTwoList = [];
      this.fc3dHistoryRedThreeList = [];
      getNextFc3dHistory(period).then(res => {
        this.fc3dHistoryList = res.data.lotteryDataList;
        this.fc3dHistoryRedOneList = res.data.num1Data;
        this.fc3dHistoryRedTwoList = res.data.num2Data;
        this.fc3dHistoryRedThreeList = res.data.num3Data;
        this.fc3dHistoryTitle = "【" + res.data.period + "】期福彩3D历史同期统计";
        this.fc3dHistoryOpen = true;
      })
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "福彩3D统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/fc3d/exportC', {
            ...this.cForm
          }, `福彩3D统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    close() {
      this.generateFc3dOpen = false;
    },
    exportFrequency() {
      this.download('/admin/lottery/fc3d/exportFrequency', {
        ...this.queryParams
      }, `福彩3D数字组合频率导出_${new Date().getTime()}.xlsx`)
    },
    handleNextNum(period) {
      this.allList = [];
      this.digitList = [];
      this.fc3dNumTitle = "【" + period + "】期福彩3D下期数字频率";
      let params = {period: period, count: null}
      getNextNumFrequency(params).then(res => {
        this.allList = res.allList;
        this.digitList = res.digitList;
        this.fc3dNumOpen = true;
      })
    }
  }
}
</script>

